import { render } from "./DigitalDeliveryCheckboxField.vue?vue&type=template&id=de6852fe"
import script from "./DigitalDeliveryCheckboxField.vue?vue&type=script&lang=js"
export * from "./DigitalDeliveryCheckboxField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__